<template>
  <div class="searchBarContainer">
    <b-icon-search class="searchIcon"></b-icon-search>
    <input class="searchBarInput" type="text" placeholder="Recherche">
  </div>
</template>
<script>
export default {
  name : "SearchBar"
}
</script>